import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import activeOrders from './mock-data/active-orders.json';
import currentUser from './mock-data/current-user.json';
import inactiveOrders from './mock-data/inactive-orders.json';
import ordersCountMetadata from './mock-data/orders-count-metadata.json';

@Injectable()
export class MockBackendInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.url.includes('/current-user')) {
      return this.successfulResponse(currentUser);
    }

    if (request.url.includes('orders/count')) {
      return this.successfulResponse(ordersCountMetadata);
    }
    if (request.url.includes('/orders/active')) {
      return this.successfulResponse(activeOrders);
    }

    if (request.url.includes('/orders/inactive')) {
      return this.successfulResponse(inactiveOrders);
    }
    return next.handle(request);
  }

  private successfulResponse(
    body: any,
    status = 200,
  ): Observable<HttpEvent<any>> {
    return of(
      new HttpResponse({
        status,
        body,
      }),
    );
  }
}
